import styled from 'styled-components';
import processArrowSvg from '../../assets/content/process-arrow.svg';
import infoSvg from '../../assets/icons/content/info.svg';
import { COLOR_CI_BLUE, COLOR_GREY } from '../../config';

type ProcessSlideProps = {
    image?: JSX.Element | undefined;
    step?: number | undefined;
    headline: string;
    children: any;
};

const ProcessSlideBox = styled.div`
    width: 28rem;
    height: 32rem;
    background: #fff;
    box-sizing: border-box;
    border-radius: 0.3rem;
    box-shadow: 0.25rem 0.5rem 1rem -0.6rem rgba(0, 0, 0, 0.12);
    padding: 2.1rem;
`;

const ProcessSlideStep = styled.div`
    background: ${COLOR_CI_BLUE};
    display: inline-block;
    font-size: 1.5rem;
    padding: 0.7rem 0.5rem;
    color: #fff;
`;

const ProcessSlideHeadline = styled.div`
    color: ${COLOR_CI_BLUE};
    font-size: 1.5rem;
    line-height: 1.15;
`;

const ProcessStepHeader = styled.div`
    border-bottom: dotted 0.15rem ${COLOR_CI_BLUE};
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1.5rem;
    margin-bottom: 2rem;
`;

const ProcessStepContent = styled.div`
    color: ${COLOR_GREY};
    line-height: 1.15;
`;

const ProcessStepImage = styled.div`
    height: 12rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;
`;

export const FittingImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export function ProcessStepSlide(props: ProcessSlideProps) {
    return <ProcessSlideBox>
        {props.image && <ProcessStepImage>
            {props.image}
        </ProcessStepImage>}
        <div>
            <ProcessStepHeader>
                {props.step && <ProcessSlideStep>{props.step}.</ProcessSlideStep>}
                <ProcessSlideHeadline>
                    {props.headline}
                </ProcessSlideHeadline>
            </ProcessStepHeader>

            <ProcessStepContent>
                {props.children}
            </ProcessStepContent>
        </div>
    </ProcessSlideBox>
}

const ProcessStepArrowImage = styled.img`
    width: 6rem;
    margin-top: 2rem;
`;

export const ProcessStepArrow = () => <ProcessStepArrowImage src={processArrowSvg} />;

export const ProcessStepSpacer = styled.div`
    width: 9rem;
    display: flex;
    justify-content: center;
`;

export const InfoBoxContent = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
`;

export const ProcessPageInfoIcon = () => <img src={infoSvg} style={{width: '2.2rem'}} />;

export const ProcessPageScrollerContent = styled.div`
    display: flex;
    align-Items: flex-start;
    padding: 0 4rem;
`;
